import { GTW_STATUS } from 'utils/constants';
import {
  CREATE_PAYMENT_DEVICE,
  CREATE_PAYMENT_DEVICE_FAILURE,
  CREATE_PAYMENT_DEVICE_SUCCESS,
  DELETE_PAYMENT_DEVICE,
  DELETE_PAYMENT_DEVICE_FAILURE,
  DELETE_PAYMENT_DEVICE_SUCCESS,
  FETCH_PAYMENT_SOLUTIONS,
  FETCH_PAYMENT_SOLUTIONS_FAILURE,
  FETCH_PAYMENT_SOLUTIONS_SUCCESS,
  FETCH_ALL_PAYMENT_SOLUTIONS,
  FETCH_ALL_PAYMENT_SOLUTIONS_FAILURE,
  FETCH_ALL_PAYMENT_SOLUTIONS_SUCCESS,
  UPDATE_PAYMENT_SOLUTIONS,
  UPDATE_PAYMENT_SOLUTIONS_SUCCESS,
  UPDATE_PAYMENT_SOLUTIONS_FAILURE,
  GET_CARD_READER_CONFIG,
  GET_CARD_READER_CONFIG_FAILURE,
  GET_CARD_READER_CONFIG_SUCCESS,
  GET_CARD_READER_VALUES,
  GET_CARD_READER_VALUES_FAILURE,
  GET_CARD_READER_VALUES_SUCCESS,
  GET_DEFAULT_PROVIDER,
  GET_DEFAULT_PROVIDER_FAILURE,
  GET_DEFAULT_PROVIDER_SUCCESS,
  GET_PAYMENT_DEVICE,
  GET_PAYMENT_DEVICE_FAILURE,
  GET_PAYMENT_DEVICE_SUCCESS,
  GET_PAYMENT_STATUS,
  GET_PAYMENT_STATUS_FAILURE,
  GET_PAYMENT_STATUS_SUCCESS,
  GET_POS_LOCATIONS,
  GET_POS_LOCATIONS_FAILURE,
  GET_POS_LOCATIONS_SUCCESS,
  RESET,
  RESET_CARD_READER_VALUES,
  RESET_DEVICE_CREATED,
  RESET_DEVICE_DELETED,
  RESET_DEVICE_STATUS,
  RESET_DEVICE_UPDATED,
  RESET_PAYMENT_DEVICE_LIST,
  RESET_SAVE_CARD_READER_VALUES,
  RESET_SAVE_DEFAULT_CARD_READER_VALUES,
  RESET_CREATE_DEFAULT_CONFIG,
  SAVE_CARD_READER_VALUES,
  SAVE_CARD_READER_VALUES_FAILURE,
  SAVE_CARD_READER_VALUES_SUCCESS,
  SAVE_DEFAULT_CARD_READER_VALUES,
  SAVE_DEFAULT_CARD_READER_VALUES_FAILURE,
  SAVE_DEFAULT_CARD_READER_VALUES_SUCCESS,
  SET_FILTERED_LIST_SUCCESS,
  TEST_PAYMENT_DEVICE,
  TEST_PAYMENT_DEVICE_FAILURE,
  TEST_PAYMENT_DEVICE_SUCCESS,
  UPDATE_PAYMENT_DEVICE,
  UPDATE_PAYMENT_DEVICE_FAILURE,
  UPDATE_PAYMENT_DEVICE_SUCCESS,
  GET_MSOPERMISSIONS,
  GET_MSOPERMISSIONS_SUCCESS,
  GET_MSOPERMISSIONS_FAILURE,
  FETCH_CHANNEL_CONFIGURATION,
  FETCH_CHANNEL_CONFIGURATION_SUCCESS,
  FETCH_CHANNEL_CONFIGURATION_FAILURE,
  UPDATE_CHANNEL_CONFIGURATION,
  UPDATE_CHANNEL_CONFIGURATION_SUCCESS,
  UPDATE_CHANNEL_CONFIGURATION_FAILURE,
  GET_DEFAULT_CONFIGURATIONS,
  GET_DEFAULT_CONFIGURATIONS_SUCCESS,
  GET_DEFAULT_CONFIGURATIONS_FAILURE,
  CREATE_DEFAULT_CONFIGURATION,
  CREATE_DEFAULT_CONFIGURATION_SUCCESS,
  CREATE_DEFAULT_CONFIGURATION_FAILURE,
  FETCH_COMPONENT_SDK_CONFIG,
  FETCH_COMPONENT_SDK_CONFIG_SUCCESS,
  FETCH_COMPONENT_SDK_CONFIG_FAILURE,
  UPDATE_COMPONENT_SDK_CONFIG,
  UPDATE_COMPONENT_SDK_CONFIG_SUCCESS,
  UPDATE_COMPONENT_SDK_CONFIG_FAILURE,
} from './actions';
import {
  ConfigurationInputType,
  PAYMENT_CONFIG,
  PaymentDeviceConfig,
} from './type';

export const INITIAL_STATE: PAYMENT_CONFIG.PaymentConfigReducer = {
  isLoading: 0,
  error: {} as PAYMENT_CONFIG.Error,
  paymentSolutions: {} as PAYMENT_CONFIG.IPaymentSolutions,
  allPaymentSolutions: {} as PAYMENT_CONFIG.IFetchAllProcessors,
  defaultProcessor: {} as PAYMENT_CONFIG.IFetchDefaultProcessor,
  defaultConfigurations: {} as PAYMENT_CONFIG.IFetchDefaultConfigurations,
  filteredList: undefined,
  paymentDeviceList: undefined,
  paymentDeviceCreated: false,
  paymentDeviceUpdated: false,
  deviceStatus: {} as PAYMENT_CONFIG.IDeviceStatus,
  deviceDeleted: false,
  getCardReaderValues: {} as PAYMENT_CONFIG.IGetCardReaderList,
  saveCardReader: false,
  saveDefaultCardReader: false,
  createDefaultConfig: false,
  paymentConfiguration: {} as PAYMENT_CONFIG.IProcessorConfigurationObj,
  posLocationList: undefined,
  paymentStatus: GTW_STATUS.UNDEFINED,
  msoPermissionsList: undefined,
  channelConfiguration: undefined,
  componentSdkConfig: undefined,
  componentSdkConfigUpdated: false,
};

const paymentConfigReducer = (
  action: IAction,
  state = INITIAL_STATE
): PAYMENT_CONFIG.PaymentConfigReducer => {
  switch (action.type) {
    case FETCH_PAYMENT_SOLUTIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as PAYMENT_CONFIG.Error,
        paymentSolutions: {} as PAYMENT_CONFIG.IPaymentSolutions,
      };
    case FETCH_PAYMENT_SOLUTIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as PAYMENT_CONFIG.Error,
        paymentSolutions: action.payload.data,
      };
    case FETCH_PAYMENT_SOLUTIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchPaymentSolutions: action.payload.message },
      };
    case FETCH_ALL_PAYMENT_SOLUTIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as PAYMENT_CONFIG.Error,
        allPaymentSolutions: {} as PAYMENT_CONFIG.IFetchAllProcessors,
      };
    case FETCH_ALL_PAYMENT_SOLUTIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as PAYMENT_CONFIG.Error,
        allPaymentSolutions: action.payload,
      };
    case FETCH_ALL_PAYMENT_SOLUTIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchDefaultProvider: action.payload.message },
      };
    case UPDATE_PAYMENT_SOLUTIONS:
      return {
        ...state,
        isLoading: state.isLoading, // Don't increment loading count here
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_PAYMENT_SOLUTIONS_SUCCESS:
      const updatedProcessors =
        action.payload?.data?.processor?.processors || [];
      const currentProcessors = state.allPaymentSolutions?.data || [];

      const updatedAllProcessors = currentProcessors.map((processor) => {
        if (!processor) return processor;
        const updated = updatedProcessors.find(
          (p: any) => p.processorId === processor.processorId
        );
        return updated ? { ...processor, ...updated } : processor;
      });

      return {
        ...state,
        allPaymentSolutions: {
          ...state.allPaymentSolutions,
          data: updatedAllProcessors,
        },
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_PAYMENT_SOLUTIONS_FAILURE:
      return {
        ...state,
        error: { updatePaymentSolutions: action.payload.message },
      };
    case GET_DEFAULT_PROVIDER:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        defaultProcessor: {} as PAYMENT_CONFIG.IFetchDefaultProcessor,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_DEFAULT_PROVIDER_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        defaultProcessor: action.payload,
      };
    case GET_DEFAULT_PROVIDER_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchDefaultProvider: action.payload.message },
      };
    case GET_DEFAULT_CONFIGURATIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        defaultConfigurations: {} as PAYMENT_CONFIG.IFetchDefaultConfigurations,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_DEFAULT_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        defaultConfigurations: action.payload,
      };
    case GET_DEFAULT_CONFIGURATIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchDefaultConfigurations: action.payload.message },
      };
    case CREATE_DEFAULT_CONFIGURATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        createDefaultConfig: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case CREATE_DEFAULT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        createDefaultConfig: true,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case CREATE_DEFAULT_CONFIGURATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        createDefaultConfig: false,
        error: { createDefaultConfiguration: action.payload.message },
      };

    case SET_FILTERED_LIST_SUCCESS:
      return {
        ...state,
        filteredList: action.payload,
      };
    case GET_PAYMENT_DEVICE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        paymentDeviceList: undefined,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_PAYMENT_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceList: action.payload.data,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_PAYMENT_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceList: {} as PAYMENT_CONFIG.IGetPaymentDeviceLocation[],
        error: { getPaymentDevice: action.payload.message },
      };
    case CREATE_PAYMENT_DEVICE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        paymentDeviceCreated: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case CREATE_PAYMENT_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceCreated: true,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case CREATE_PAYMENT_DEVICE_FAILURE: {
      const message =
        typeof action.payload === 'string'
          ? action.payload
          : action.payload?.message;
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceCreated: false,
        error: { createPaymentDevice: { message } },
      };
    }

    case UPDATE_PAYMENT_DEVICE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        paymentDeviceUpdated: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_PAYMENT_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceUpdated: true,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_PAYMENT_DEVICE_FAILURE: {
      const message =
        typeof action.payload === 'string'
          ? action.payload
          : action.payload?.message;
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentDeviceUpdated: false,
        error: { editPaymentDevice: { message } },
      };
    }
    case TEST_PAYMENT_DEVICE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        deviceStatus: {} as PAYMENT_CONFIG.IDeviceStatus,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case TEST_PAYMENT_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        deviceStatus: action.payload.data,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case TEST_PAYMENT_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        deviceStatus: {} as PAYMENT_CONFIG.IDeviceStatus,
        error: { deviceStatus: action.payload.message },
      };
    case DELETE_PAYMENT_DEVICE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        deviceDeleted: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case DELETE_PAYMENT_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        deviceDeleted: true,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case DELETE_PAYMENT_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        deviceDeleted: false,
        error: { deviceDeleted: action.payload.message },
      };
    case GET_CARD_READER_VALUES:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        getCardReaderValues: {} as PAYMENT_CONFIG.IGetCardReaderList,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_CARD_READER_VALUES_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        getCardReaderValues: action.payload.data,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_CARD_READER_VALUES_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        getCardReaderValues: {} as PAYMENT_CONFIG.IGetCardReaderList,
        error: { getCardReaderValues: action.payload.message },
      };
    case SAVE_CARD_READER_VALUES:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        saveCardReader: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case SAVE_CARD_READER_VALUES_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        saveCardReader: true,
        error: {} as PAYMENT_CONFIG.Error,
      };

    case SAVE_CARD_READER_VALUES_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        saveCardReader: false,
        error: { saveCardReader: action.payload.message },
      };
    case SAVE_DEFAULT_CARD_READER_VALUES:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        saveDefaultCardReader: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case SAVE_DEFAULT_CARD_READER_VALUES_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        saveDefaultCardReader: true,
        error: {} as PAYMENT_CONFIG.Error,
      };

    case SAVE_DEFAULT_CARD_READER_VALUES_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        saveDefaultCardReader: false,
        error: { saveDefaultCardReader: action.payload.message },
      };
    case GET_CARD_READER_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        paymentConfiguration: {} as PAYMENT_CONFIG.IProcessorConfigurationObj,
        error: {} as PAYMENT_CONFIG.Error,
      };

    case GET_CARD_READER_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentConfiguration: action?.payload?.data,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_CARD_READER_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentConfiguration: {} as PAYMENT_CONFIG.IProcessorConfigurationObj,
        error: { paymentConfiguration: action.payload?.message },
      };

    case GET_POS_LOCATIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        posLocationList: [] as PAYMENT_CONFIG.IPosLocation[],
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_POS_LOCATIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        posLocationList: action.payload.data,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_POS_LOCATIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        posLocationList: [] as PAYMENT_CONFIG.IPosLocation[],
        error: { getPosLocation: action.payload?.message },
      };
    case GET_MSOPERMISSIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        msoPermissionsList: {} as PAYMENT_CONFIG.IMSOPermissionsList,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_MSOPERMISSIONS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        msoPermissionsList: action.payload,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_MSOPERMISSIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        msoPermissionsList: {} as PAYMENT_CONFIG.IMSOPermissionsList,
        error: { getMsoPermissionList: action.payload?.message },
      };

    case RESET_DEVICE_DELETED:
      return {
        ...state,
        deviceDeleted: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET_DEVICE_UPDATED:
      return {
        ...state,
        paymentDeviceUpdated: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET_DEVICE_CREATED:
      return {
        ...state,
        paymentDeviceCreated: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET_PAYMENT_DEVICE_LIST:
      return {
        ...state,
        paymentDeviceList: undefined,
      };
    case RESET_SAVE_CARD_READER_VALUES:
      return {
        ...state,
        saveCardReader: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET_SAVE_DEFAULT_CARD_READER_VALUES:
      return {
        ...state,
        saveDefaultCardReader: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET_CREATE_DEFAULT_CONFIG:
      return {
        ...state,
        createDefaultConfig: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case RESET:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as PAYMENT_CONFIG.Error,
        deviceStatus: {} as PAYMENT_CONFIG.IDeviceStatus,
      };
    case RESET_DEVICE_STATUS:
      return {
        ...state,
        deviceStatus: {} as PAYMENT_CONFIG.IDeviceStatus,
      };
    case RESET_CARD_READER_VALUES:
      return {
        ...state,
        getCardReaderValues: {} as PAYMENT_CONFIG.IGetCardReaderList,
        paymentConfiguration: {} as PAYMENT_CONFIG.IProcessorConfigurationObj,
      };
    case GET_PAYMENT_STATUS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        paymentStatus: GTW_STATUS.UNDEFINED,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentStatus: action.payload.data.status,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case GET_PAYMENT_STATUS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        paymentStatus: GTW_STATUS.UNDEFINED,
        error: { deviceStatus: action.payload.message },
      };
    case FETCH_CHANNEL_CONFIGURATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case FETCH_CHANNEL_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        channelConfiguration: action.payload?.data ?? [],
        error: {} as PAYMENT_CONFIG.Error,
      };
    case FETCH_CHANNEL_CONFIGURATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchChannelConfig: action.payload?.message },
      };
    case UPDATE_CHANNEL_CONFIGURATION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_CHANNEL_CONFIGURATION_SUCCESS:
      const updatedConfigs: PAYMENT_CONFIG.IChannelFlowConfigNullable[] =
        action.payload?.data || [];

      const mergedConfigs = [
        ...(Array.isArray(state?.channelConfiguration)
          ? state?.channelConfiguration?.filter(
              (conf) =>
                !updatedConfigs.find((upd) => upd.channel === conf.channel)
            )
          : []),
        ...updatedConfigs,
      ];

      return {
        ...state,
        isLoading: state.isLoading - 1,
        channelConfiguration: mergedConfigs,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_CHANNEL_CONFIGURATION_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { updateChannelConfig: action.payload.message },
      };
    case FETCH_COMPONENT_SDK_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case FETCH_COMPONENT_SDK_CONFIG_SUCCESS: {
      const config: PAYMENT_CONFIG.IComponentSdkConfig = action.payload?.data;
      return {
        ...state,
        isLoading: state.isLoading - 1,
        componentSdkConfig: {
          ...state.componentSdkConfig,
          [config.channel]: config,
        },
        error: {} as PAYMENT_CONFIG.Error,
      };
    }
    case FETCH_COMPONENT_SDK_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {
          fetchComponentSdkConfig: { message: action.payload?.message },
        },
      };
    case UPDATE_COMPONENT_SDK_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        componentSdkConfigUpdated: false,
        error: {} as PAYMENT_CONFIG.Error,
      };
    case UPDATE_COMPONENT_SDK_CONFIG_SUCCESS: {
      const updatedConfig: PAYMENT_CONFIG.IComponentSdkConfig | undefined =
        action.payload?.data;
      return {
        ...state,
        isLoading: state.isLoading - 1,
        componentSdkConfigUpdated: true,
        componentSdkConfig: updatedConfig
          ? {
              ...state.componentSdkConfig,
              [updatedConfig.channel]: updatedConfig,
            }
          : state.componentSdkConfig,
        error: {} as PAYMENT_CONFIG.Error,
      };
    }
    case UPDATE_COMPONENT_SDK_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        componentSdkConfigUpdated: false,
        error: {
          updateComponentSdkConfig: { message: action.payload?.message },
        },
      };
    default:
      return state;
  }
};
export default paymentConfigReducer;
